import React from 'react';
import ChatbotWidget from './ChatbotWidget';
import './AboutLoyalTapLogin.css';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AboutLoyalTapLogin = () => {
  const { t } = useTranslation();

  return (
    <div className="about-loyaltap-wrapper">
      <div className="about-text">
        <h2>📘 {t('about.title_loyaltap')}</h2>
        <p>{t('about.description')}</p>
        <ul>
          <li>{t('about.point1')}</li>
          <li>{t('about.point2')}</li>
          <li>{t('about.point3')}</li>
          <li>{t('about.point4')}</li>
        </ul>
      </div>

      <div className="chatbot-box">
        <h3>{t('about.assistant')}</h3>
        <p>{t('about.suggestLabel')}</p>
        <ul>
          <li>{t('about.suggest1')}</li>
          <li>{t('about.suggest2')}</li>
          <li>{t('about.suggest3')}</li>
          <li>{t('about.suggest4')}</li>
          <li>{t('about.suggest5')}</li>
        </ul>
        <ChatbotWidget coffeeShopId="location1" />
        <h4>{t('about.chat_in_language')}</h4>
        <Link to="/" className="back-to-login-button">← {t('about.back')}</Link>
      </div>
    </div>
  );
};

export default AboutLoyalTapLogin;